

  const  Number= [
     {
        quizNo: 2026,
        name: 'Quiz',
        topic: 'l'
      },
      {
        quizNo: 2025,
        name: 'Quiz',
        topic: 'a'
      },
      {
        quizNo: 2024,
        name: 'Quiz',
         topic: 'b'
      },
      {
        quizNo: 2023,
        name: 'Quiz',
         topic: 'c'
      },
      {
        quizNo: 2022,
        name: 'Quiz',
         topic: 'd'
      },
      {
        quizNo: 2021,
        name: 'Quiz',
         topic: 'e'
      },
        {
        quizNo: 2020,
        name: 'Quiz',
        topic: 'f'
      },
      {
        quizNo: 2019,
        name: 'Quiz',
         topic: 'g'
      },
      {
        quizNo: 2018,
        name: 'Quiz',
         topic: 'h'
      },
      {
        quizNo: 2017,
        name: 'Quiz',
         topic: 'i'
      },
      {
        quizNo: 2016,
        name: 'Quiz',
         topic: 'j'
      },
        {
        quizNo: 2015,
        name: 'Quiz',
        topic: 'k'
      }
  ]
  

  export default Number;